(function () {
var $8ec7dcaec38426ec$var$loadMoreEvents = {
    settings: {
        postsNumber: 0,
        offset: 9,
        postType: null,
        termId: 0,
        taxonomy: null,
        datecurrent: null
    },
    init: function init() {
        var eventsContainer = document.querySelector(".container--events");
        if (!eventsContainer) return;
        console.log("test");
        this.settings.postType = eventsContainer.dataset.postType;
        this.settings.termId = eventsContainer.dataset.termId;
        this.settings.taxonomy = eventsContainer.dataset.taxonomy;
        this.settings.datecurrent = eventsContainer.dataset.datecurrent;
        this.loadMore();
    },
    loadMore: function() {
        var loadMoreBtn = document.querySelector(".container--events #load-more");
        loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.addEventListener("click", function() {
            $8ec7dcaec38426ec$var$loadMoreEvents.getItems();
        });
    },
    getItems: function() {
        var loader = document.querySelector(".loader-container");
        var submit = document.querySelector(".container--events #load-more");
        var ajax_data = {
            action: ajax.action_name,
            nonce: ajax.nonce,
            offset: $8ec7dcaec38426ec$var$loadMoreEvents.settings.offset,
            post_type: $8ec7dcaec38426ec$var$loadMoreEvents.settings.postType,
            term_id: $8ec7dcaec38426ec$var$loadMoreEvents.settings.termId,
            taxonomy: $8ec7dcaec38426ec$var$loadMoreEvents.settings.taxonomy,
            datecurrent: $8ec7dcaec38426ec$var$loadMoreEvents.settings.datecurrent
        };
        jQuery.ajax({
            type: "POST",
            url: ajax.ajax_url,
            data: ajax_data,
            beforeSend: function() {
                loader.classList.add("var_active");
                submit.classList.add("var_disabled");
            },
            success: function(data) {
                var response = data.data;
                var html = response.html;
                var container = document.querySelector(".container__event-items");
                container.insertAdjacentHTML("beforeend", html);
                $8ec7dcaec38426ec$var$loadMoreEvents.buttonBehaviour(response.count);
                loader.classList.remove("var_active");
                submit.classList.remove("var_disabled");
            },
            error: function(xhr, status, errorThrown) {
                alert("Something went wrong. Please try later.");
                loader.classList.remove("var_active");
                submit.classList.remove("var_disabled");
            }
        });
    },
    buttonBehaviour: function(count) {
        var getDisplaiedEvents = document.querySelectorAll(".container__event-items .event");
        $8ec7dcaec38426ec$var$loadMoreEvents.settings.offset = getDisplaiedEvents.length;
        if (count === getDisplaiedEvents.length) {
            var submit = document.querySelector(".container--events #load-more");
            submit.classList.add("var_hide");
        }
    }
};
$8ec7dcaec38426ec$var$loadMoreEvents.init();

})();
//# sourceMappingURL=loadMoreEvents.js.map
